import { Selectbutton } from '@/shared/ui/Selectbutton'
import { useCommonCodes } from '@/shared/lib/codes'
import { figmaLabel, sortByFigma } from '@/shared/lib/figmaLabel'
import type { OrgNewDraft } from '@/public/features/org/types'
import { StepHeadLarge } from '@/public/features/org/ui/orgNew/parts'

export function StepCardCategory({ draft }: { draft: OrgNewDraft }) {
  const categories = useCommonCodes('category')

  return (
    <section className="flex flex-col gap-8">
      <StepHeadLarge
        title="어떤 분야의 문제를 해결할 수 있나요?"
        desc="해결할 수 있는 분야를 선택해 주세요."
      />
      <div className="flex flex-wrap content-start gap-3 [&>.ui-selectbutton]:min-w-[150px] [&>.ui-selectbutton]:flex-[1_0_0] [&>.ui-selectbutton]:whitespace-nowrap">
        {sortByFigma(categories.data ?? []).map((c) => (
          <Selectbutton
            key={c.code}
            size="lg"
            label={figmaLabel(c.code, c.label)}
            isOn={draft.cardCategoryCodes.includes(c.code)}
            onSelect={() => draft.toggleCardCategory(c.code)}
          />
        ))}
      </div>
    </section>
  )
}
